<template>
  <div id="ganttCM"></div>
</template>

<script>
import Highcharts from 'highcharts/highstock';
import HighchartsGantt from 'highcharts/modules/gantt';
import HighchartsExport from 'highcharts/modules/exporting'
// var elementResizeDetectorMaker = require("element-resize-detector");
HighchartsGantt(Highcharts)
HighchartsExport(Highcharts)
export default {
  name: 'ganttCM',
  
  props: ['options','type'],
  data() {
    return {
      dataChange:false,
      eleDiv:''
    }
  },
  created(){
    
  },
  mounted () {
     // 监听div尺寸变化
      // var erd = elementResizeDetectorMaker()
      // erd.listenTo(document.getElementById('rightWrap'),(ele)=>{
      //   var w = ele.offsetWidth 
      //   var h = ele.offsetHeight
      //   this.$nextTick(function(){
      //     console.log('w：',w,'h:',h)
      //   })
      // })
  },
  watch:{
    options:function(){
      this.chartInfo()
    },
    type:function(){
      this.chartInfo()
    }
  },
  destroyed () {
   
  },
  methods: {
    // 数据结构拼接
    chartInfo(){
      for (let i = 0; i < this.options.length; i++) {
        this.options[i].data[0].collapsed=this.type
        if (i == this.options.length-1){
          this.initChart()
        }
      }
    },
    // 甘特图初始化
    initChart(){
      this.eleDiv = document.getElementById('ganttCM')
      let _this = this
      var dateFormat = Highcharts.dateFormat,
          defined = Highcharts.defined,
          reduce = Highcharts.reduce;
      
      Highcharts.setOptions({
        global: {
          useUTC:false
        },
        lang: {
          downloadJPEG: _this.$t('ganttV2.downloadBtn1'),
          downloadPDF: _this.$t('ganttV2.downloadBtn2'),
          downloadPNG: _this.$t('ganttV2.downloadBtn3'),
          downloadSVG: _this.$t('ganttV2.downloadBtn4')

        }
      })
      new Highcharts.ganttChart(this.eleDiv, {
        series: _this.options,
        tooltip: {
          pointFormatter: function () {
            var point = this,
              format = '%Y-%m-%d %H:%M:%S',
              lines;
            lines = [{
              title: _this.$t('gantt.label1'),
              value: point.name,
              style: 'font-weight: bold;'
            },{
              title: _this.$t('gantt.label2'),
              value: point.part
            },{
              title: _this.$t('gantt.label3'),
              value: point.step
            },{
              title: _this.$t('gantt.label4'),
              value: point.description
            },{
              title: _this.$t('gantt.label5'),
              value: dateFormat(format, new Date(point.start))
            }, {
              title: _this.$t('gantt.label6'),
              value: dateFormat(format, new Date(point.end))
            }, {
              title: _this.$t('gantt.label7'),
              value: point.duration+'"'
            }];
            return reduce(lines, function (str, line) {
              var s = '',
                style = (
                  defined(line.style) ? line.style : 'font-size: 0.8em;'
                );
              if (line.visible !== false) {
                s = (
                  '<span style="' + style + '">' +
                  (defined(line.title) ? line.title + ': ' : '') +
                  (defined(line.value) ? line.value : '') +
                  '</span><br/>'
                );
              }
              return str + s;
            }, '');
          }
        },
        scrollbar: {
          enabled: true
        },
        rangeSelector: {
          enabled: false,
          selected: 1,
          inputEnabled: false
        },
        navigator: {
          enabled: true,
          series: {
            type: 'gantt',
            pointPlacement: 0.5,
            pointPadding: 0.25
          },
          yAxis: {
            min: 0,
            max: 3,
            reversed: true,
            categories: []
          }
        },
        exporting: {
          buttons: {
            contextButton: {
              enabled: false
            }
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ganttCM{
  width: 100%;
  height: 100%;
}
</style>